import React from 'react';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { useResponsive } from '../../../hooks/useResponsive';
import { popupSlice } from '../../../services/reducers';
import MapModal from '../../../layouts/Modal/MapModal';
import restApi from '../../../services/restApi';
import endpoints from '../../../config/endpoints';
import { IAddress } from '../../../types/types';

interface AddressesSectionProps {
  addresses: IAddress[];
  userId?: string;
  activeSection: string;
  onDelete?: () => void;
}

const AddressesSection: React.FC<AddressesSectionProps> = ({ addresses, userId, activeSection, onDelete }) => {
  const dispatch = useDispatch();
  const {
    isMobile,
  } = useResponsive();

  const handleDeleteAddress = async (addressId: string | number) => {
    const confirm = await Swal.fire({
      title: 'حذف آدرس',
      text: 'آیا از حذف این آدرس اطمینان دارید؟',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'حذف',
      cancelButtonText: 'انصراف',
    });
    if (!confirm.isConfirmed) return;
    try {
      const res = await restApi(endpoints.address.delete).post({ id: addressId });
      if (res?.data?.success === false) throw new Error();
      onDelete?.();
    } catch {
      Swal.fire({ title: 'خطا', text: 'خطا در حذف آدرس', icon: 'error', confirmButtonText: 'متوجه شدم' });
    }
  };
  return (
    <section className={`bottom ${isMobile && activeSection !== 'addresses' ? 'hidden-mobile' : ''}`}>
      <div className="section-header">
        <h6 className="dashBoardTitle">آدرس ها</h6>
        <button
          type="button"
          className="btn-add"
          onClick={() => dispatch(popupSlice.middle(<MapModal userId={userId} />))}
        >
          افزودن آدرس
        </button>
      </div>

      <div className={`addresses-container ${isMobile ? 'mobile-addresses' : ''}`}>
        {addresses.length > 0 ? (
          addresses.map(address => (
            <div key={address.id} className={`address-card ${isMobile ? 'mobile-address-card' : 'bottomDiv'}`}>
              <div className="address-content">
                <div className="address-info">
                  <div className="address-header">
                    <i className="mapPin"></i>
                    <h6>{address?.title}</h6>
                  </div>
                  <p className="address-text">
                    {address?.description}
                    <br/>
                    {address?.phoneNumber}
                  </p>
                </div>
                <div className="address-actions">
                  <img src="/img/map.jpg" className="map-photo" alt="Map" />
                  <button
                    type="button"
                    className="edit-address-btn"
                    onClick={() => dispatch(popupSlice.middle(<MapModal userId={userId} address={address} />))}
                  >
                    <i className="edit"></i>
                  </button>
                  <button
                    type="button"
                    className="delete-address-btn"
                    onClick={() => handleDeleteAddress(address.id)}
                  >
                    <i className="delete"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data-message">
            <p>هیچ آدرسی ثبت نشده است</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default AddressesSection;
